import { TextField } from '@/ui/form/controls/TextField'
import * as React from 'react'
import { useDriverForm } from '@/modules/drivers/context/DriverFormContext'
// import { FieldsetSelect } from '@/modules/settings/components/FieldsetSelect'
// import useDriverFieldSetOptions from '../options/useDriverFieldSetOptions'
// import { Divider } from '../../shared/Divider'

const OthersStage = () => {
  // const { driverLicenceOptions } = useDriverFieldSetOptions()
  const { data, setData } = useDriverForm()
  return (
    <div className="tw-flex tw-justify-between">
      <div className="tw-w-full tw-max-w-[256px]">
        <p className="tw-text-lg tw-font-semibold tw-text-content-base">
          Inne
        </p>
      </div>
      <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-4">
        <TextField
          label="Id import"
          placeholder="Wpisz..."
          value={data?.customId}
          onChange={(e) => setData({ ...data, customId: e.target.value })}
        />
        <TextField
          label="Id eksport"
          placeholder="Wpisz..."
          value={data?.externalId}
          onChange={(e) => setData({ ...data, externalId: e.target.value })}
        />
        {/* @TODO ALIAS GPS */}
        {/* <TextField
          label="Alias GPS"
          placeholder="Wpisz..."
          value={data?.gpsAlias}
          onChange={(e) => setData({ ...data, gpsAlias: e.target.value })}
      /> */}
        {/*
        <FieldsetSelect
          label="Typ licencji"
          options={driverLicenceOptions}
          value={data?.licenseType ?? ''}
          onChange={(e) => setData({ ...data, licenseType: e.target.value })}
        />
        <Divider />
        */}
        {/* @TODO  */}
        {/* <Divider />
        <div className="tw-flex tw-items-center tw-justify-between tw-gap-2">
          <p className="tw-text-sm tw-font-medium tw-text-content-base">
            Nie przeliczaj naruszeń podczas zapisu aktywności
          </p>
          <Switch
            checked={}
            onChange={(e) => setSkipViolations(e.target.checked)}
          /> 
        </div>*/}
      </div>
    </div>
  )
}

export default OthersStage
